import React from 'react';
import { cn } from '../../lib/utils';
import { ChevronRight } from 'lucide-react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  size?: 'lg' | 'xl';
  pulse?: boolean;
  showIcon?: boolean;
}
export function CTAButton({
  text,
  size = 'lg',
  pulse = false,
  showIcon = true,
  className,
  ...props
}: CTAButtonProps) {
  return <button className={cn('relative group inline-flex items-center justify-center font-bold text-white transition-all duration-300 transform hover:scale-105 hover:shadow-xl active:scale-95', 'bg-gradient-to-r from-red-600 to-red-500 rounded-full shadow-lg', size === 'lg' ? 'py-4 px-8 text-lg' : 'py-5 px-10 text-xl md:text-2xl', className)} {...props} data-id="element-137">
      {pulse && <span className="absolute -inset-1 rounded-full bg-red-500 opacity-75 animate-ping" data-id="element-138" />}
      <span className="relative flex items-center gap-2" data-id="element-139">
        {text}
        {showIcon && <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-140" />}
      </span>
    </button>;
}